<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.si_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="si_name">
            <label class="weui-form-preview__label">{{customLabel.si_name || "名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.si_name}}</em>
          </div>
          <div class="weui-form-preview__item" slot="si_spec">
            <label class="weui-form-preview__label">{{customLabel.si_spec || "规格"}}</label>
            <em class="weui-form-preview__value">{{form.main.si_spec}}</em>
          </div>
          <div class="weui-form-preview__item" slot="si_unit">
            <label class="weui-form-preview__label">{{customLabel.si_unit || "单位"}}</label>
            <em class="weui-form-preview__value">{{form.main.si_unit}}</em>
          </div>
          <div class="weui-form-preview__item" slot="si_currency">
            <label class="weui-form-preview__label">{{customLabel.si_currency || "币别"}}</label>
            <em class="weui-form-preview__value">{{form.main.si_currency}}</em>
          </div>
          <div class="weui-form-preview__item" slot="si_price">
            <label class="weui-form-preview__label">{{customLabel.si_price || "含税单价(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(form.main.si_price,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="si_renewprice">
            <label class="weui-form-preview__label">{{customLabel.si_renewprice || "续费单价(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(form.main.si_renewprice,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="si_remark">
            <label class="weui-form-preview__label">{{customLabel.si_remark || "备注"}}</label>
            <em class="weui-form-preview__value">{{form.main.si_remark}}</em>
          </div>
        </custom-layout>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="'/crm/serve_item_edit?id=' + form.main.id"
        v-if="form.main.si_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="form.main.si_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="form.main.si_status == '已审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="form.main.si_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/sale/serveitem",
      codeField: "si_code",
      caller: "ServeItem",
      xtype: "make-serveitem-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this

      me.$weui.confirm('确定删除单据？', function () {
        me.$loading({
          url: `/api/sale/serveitem/delete/${me.form.main.id}?caller=ServeItem`,
          method: "POST"
        }).then(res => {
          if(res.success) {
            me.$router.back()
          }
        })
      });
    }
  }
};
</script>